import {Pipe, PipeTransform} from '@angular/core';
import {Observable} from 'rxjs';
import {PermissionsService} from '../permissions.service';
import {DasAction} from '../types';

@Pipe({
  name: 'dasEnabled'
})
export class DasEnabledPipe implements PipeTransform {
  constructor(private _permissionsService: PermissionsService) {}

  /**
   * Returns the an Observable resolving to whether the user can perform the action requested.
   *
   * @param action {DasAction}             DAS action the user is looking to take
   * @returns      {Observable<boolean>}   An observable resolving whether the user can take the action requested
   */
  public transform(action: DasAction): Observable<boolean> {
    return this._permissionsService.can(action);
  }
}
